import React from "react";
import { Box, Typography } from "@material-ui/core";
import { Icon, IconName } from "halifax";
import clsx from "clsx";
import {
  AVAILABLE,
  getExperimentVariant,
  useExperiments,
  XMOD_V1_EXPERIMENT,
} from "../../../context/experiments";

import styles from "./styles.module.scss";
import { ShopComponentSkeleton } from "../../shop/component";

export interface IShopContactInformationProps {
  isSkeleton?: boolean;
  supplierEmail?: string;
  supplierPhone?: string;
  mobile?: boolean;
}

const Skeleton = () => (
  <Box className="experiences-shop-skeleton">
    <Box className="section-wrapper">
      <ShopComponentSkeleton name="medium" />
      <ShopComponentSkeleton name="large" />
      <ShopComponentSkeleton name="medium" />
    </Box>
  </Box>
);

export const ShopContactInformation = (props: IShopContactInformationProps) => {
  const { isSkeleton, supplierEmail, supplierPhone, mobile } = props;

  const expState = useExperiments();
  const isXmodRedesign =
    getExperimentVariant(expState.experiments, XMOD_V1_EXPERIMENT) ===
    AVAILABLE;

  if (isSkeleton) {
    return <Skeleton />;
  }

  return (
    <Box
      className={clsx(styles["contact-info-container"], {
        [styles.mobile]: mobile,
      })}
    >
      <Box className={styles["description-container"]}>
        <Typography variant="body2">
          For questions about meeting or pickup point, activity details, or
          special requests, contact your activity provider for more information.
        </Typography>
      </Box>
      <Box
        className={clsx(styles["contact-methods-container"], {
          [styles.mobile]: mobile,
        })}
      >
        {supplierPhone && (
          <Box className={styles["contact-method-container"]}>
            <Icon
              name={IconName.MobilePhoneIcon}
              className={clsx(styles["phone-icon"], {
                [styles.xmod]: isXmodRedesign,
              })}
            />
            <Typography variant="h6">Call</Typography>
            <Typography variant="body2">{supplierPhone}</Typography>
          </Box>
        )}
        {supplierEmail && (
          <Box className={clsx(styles["contact-method-container"])}>
            <Icon
              name={IconName.EmailIcon}
              className={clsx({
                [styles.xmod]: isXmodRedesign,
              })}
            />
            <Typography variant="h6">Email</Typography>
            <Typography variant="body2">
              {/* Provide a cleaner word break when the email needs to wrap */}
              {supplierEmail?.replace(/@/, "\u200B@")}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
